export const noFollowingSellerAreaMockedData = {
  "designerId": 633755,
  "designerName": "AssetKit",
  "avatarUrl": "https://img-new.cgtrader.com/avatars/633755/large_e6c9840b-f423-42ef-bf58-49fb15dc8b8e.jpg",
  "rating": 0,
  "reviewsCount": 1,
  "availableForHire": true,
  "isFollowing": false,
}

export const notAvailableForHireSellerAreaMockedData = {
  "designerId": 633755,
  "designerName": "AssetKit",
  "avatarUrl": "https://img-new.cgtrader.com/avatars/633755/large_e6c9840b-f423-42ef-bf58-49fb15dc8b8e.jpg",
  "rating": 100,
  "reviewsCount": 539,
  "availableForHire": false,
  "isFollowing": true,
}
